// services/apiService.js
import axios from 'axios';
import api from '../utils/apiInterceptor';
import { API_URL } from '../constants/data';

const API_ENDPOINTS = {
  // CATEGORIES: `${API_URL}/get_ai_subcategory_claude`,
  CATEGORIES: `${API_URL}/get_ai_subcategory_gpt`,
  SEMANTIC_RCA: `${API_URL}/get_semantic_rca`,
  USER_DATA: `${API_URL}/get_userdata`,
  SPATIAL_DATA: `${API_URL}/get_spatial_analysis_data`,
  FEEDBACK_DISTRIBUTION: `${API_URL}/feedback_distribution_by_es`,
  FETCH_ALL_COMPANY: `${API_URL}/get_company_details?sectorname=All&companyname=All&categoryname=All`,
  COMPANY_COUNT: `${API_URL}/search`,
  FEEDBACK_KEYWORD: `${API_URL}/get_feedback_keywords`,
  CATEGORY_ALERT: `${API_URL}/get_category_alert`,
  // FEEDBACK_STATS: `${API_URL}/get_feedback_stats`,
  FEEDBACK_STATS: `${API_URL}/get_feedback_stats_v1`,
  // FEEDBACK_BY_RATING: `${API_URL}/get_feedback_by_rating`,
  FEEDBACK_BY_RATING: `${API_URL}/get_feedback_by_rating_v1`,
  SUBCATEGORY_WITH_COUNTS: `${API_URL}/subcategory_with_counts`,
  COMPANY_OFFERS: `https://citizenconsumeraffairs.com/doca_api/get_company_offer_to_consumer`,
};



const getAccessToken = () => {
  return localStorage.getItem("access_token") || "";
};

export const apiService = {
  fetchCategories: async (prompt) => {
    const response = await api.post(API_ENDPOINTS.CATEGORIES, {
      input_prompt: prompt,
      max_retries: 3,
    });
    return response.data;
  },

  fetchSemanticRCA: async (params) => {
    const response = await api.post(API_ENDPOINTS.SEMANTIC_RCA, {
      query: params.query,
      start_date: params.startDate,
      end_date: params.endDate,
      threshold: params.threshold || 1.3,
      value: params.value || 1,
      purchaseCity: 'All',
      stateName: 'All',
      complaintType: 'All',
      complaintMode: 'All',
      companyName: 'All',
      complaintStatus: 'All',
      complainNumbers: params.complaintNumbers || ["NA"]
    });
    return response.data;
  },

  fetchUserData: async (params) => {
    // params can be an array of IDs (legacy) or an object with ids, skip, size
    const payload = Array.isArray(params) ? { ids: params } : params;

    const response = await api.post(API_ENDPOINTS.USER_DATA, payload);
    return response.data.data;
  },

  fetchSpatialData: async (params) => {
    const SUB_SPATIAL_CACHE_KEY = "subStateDataCache";
    const CACHE_EXPIRY_HOURS = 24;
    const cacheKey = SUB_SPATIAL_CACHE_KEY

    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey) || "{}");
      const isCacheValid = (timestamp) => {
        if (!timestamp) return false;
        const age = (Date.now() - timestamp) / (1000 * 60 * 60);
        return age < CACHE_EXPIRY_HOURS;
      };

      if (cached?.prompt === params.query && cached?.timestamp && isCacheValid(cached.timestamp)) {
        return cached.data;
      } else if (cached?.prompt && cached.prompt !== params.query) {
        console.log("🔄 Different spatial params detected, will fetch fresh data");
      }
    } catch (cacheError) {
      console.warn('Failed to read spatial cache:', cacheError);
    }


    const response = await api.post(API_ENDPOINTS.SPATIAL_DATA, {
      query: params.query,
      start_date: params.startDate.toISOString().split('T')[0],
      end_date: params.endDate.toISOString().split('T')[0],
      value: params.value || 1,
      purchaseCity: 'All',
      stateName: 'All',
      complaintType: 'All',
      complaintMode: 'All',
      companyName: 'All',
      complaintStatus: 'All',
      threshold: params.threshold || 1.3,
      complainNumbers: params.complaintNumbers || ["NA"]
    });

    let responseData = response.data;
    responseData = Object.entries(responseData).map(([key, value]) => ({
      key: key,
      doc_count: value
    }));

    try {
      localStorage.setItem(SUB_SPATIAL_CACHE_KEY, JSON.stringify({
        prompt: params.query,
        timestamp: Date.now(),
        data: responseData
      }));
    } catch (cacheError) {
      console.warn('Failed to cache spatial data:', cacheError);
    }

    return responseData;
  },

  // fetchCategoryWithCount: async (categoryData, filters = {}) => {
  //   const SUBCATEGORY_CACHE_KEY = "currentSubcategoryData";
  //   const CACHE_EXPIRY_HOURS = 24;

  //   try {
  //     const cached = JSON.parse(localStorage.getItem(SUBCATEGORY_CACHE_KEY) || "{}");
  //     const isCacheValid = (timestamp) => {
  //       if (!timestamp) return false;
  //       const age = (Date.now() - timestamp) / (1000 * 60 * 60);
  //       return age < CACHE_EXPIRY_HOURS;
  //     };

  //     if (cached?.prompt === categoryData[1].prompt && cached?.timestamp && isCacheValid(cached.timestamp)) {
  //       return {
  //         updatedData: cached.data.categories || {},
  //         totalCount: cached.data.totalCount || 0
  //       };
  //     } else if (cached?.prompt && cached.prompt !== categoryData[1].prompt) {
  //       console.log("🔄 Different prompt detected, will fetch fresh data. Cached:", cached.prompt, "Requested:", categoryData[1].prompt);
  //     }
  //   } catch (cacheError) {
  //     console.warn('Failed to read subcategory cache:', cacheError);
  //   }


  //   try {
  //     const categoryRes = await api.post(
  //       API_ENDPOINTS.CATEGORIES,
  //       {
  //         input_prompt: categoryData[1].prompt,
  //         max_retries: 3,
  //       },
  //     );

  //     const categoriesData = categoryRes?.data || {};

  //     const baseCategories = Object.entries(categoriesData).reduce((acc, [key, value]) => {
  //       acc[key] = {
  //         prompt: value.prompt || '',
  //         count: 0,
  //       };
  //       return acc;
  //     }, {});

  //     const categoryNames = Object.keys(baseCategories);

  //     // Handle empty response from API
  //     if (categoryNames.length === 0) {
  //       console.warn('No subcategories found for prompt:', categoryData[1].prompt);
  //       return {
  //         updatedData: {},
  //         totalCount: 0,
  //         totalCategories: 0,
  //       };
  //     }

  //     const updatedCategories = { ...baseCategories };

  //     let totalComplaints = 0;
  //     const batchSize = 5;

  //     for (let i = 0; i < categoryNames.length; i += batchSize) {
  //       const batch = categoryNames.slice(i, i + batchSize);

  //       const batchResults = await Promise.all(
  //         batch.map(async (categoryName) => {
  //           try {
  //             const startDate = filters.startDate
  //               ? new Date(filters.startDate).toISOString().split('T')[0]
  //               : new Date(new Date().getFullYear() - 2, 0, 1).toISOString().split('T')[0];

  //             const endDate = filters.endDate
  //               ? new Date(filters.endDate).toISOString().split('T')[0]
  //               : new Date().toISOString().split('T')[0];


  //             const response = await axios.post(
  //               API_ENDPOINTS.SEMANTIC_RCA,
  //               {
  //                 query: categoryName,
  //                 skip: 0,
  //                 size: 0,
  //                 start_date: startDate,
  //                 end_date: endDate,
  //                 value: filters?.value || 1,
  //                 CityName: "All",
  //                 stateName: "All",
  //                 complaintType: "All",
  //                 complaintMode: "All",
  //                 companyName: "All",
  //                 complaintStatus: "All",
  //                 threshold: filters?.threshold || 1.5,
  //                 complaint_numbers: categoryData[1].complaintNumbers,
  //               },
  //               {
  //                 headers: {
  //                   Accept: "application/json",
  //                   "Content-Type": "application/json",
  //                   'Authorization': `Bearer ${getAccessToken()}`
  //                 },
  //                 timeout: 15000,
  //               }
  //             );

  //             let count = response.data?.total_counts || 0;
  //             const complaintNumbers = response.data?.complaintNumbers || [];

  //             return { categoryName, count, complaintNumbers, isSuccess: true };
  //           } catch (err) {
  //             const fallbackCount = Math.floor(Math.random() * (200 - 50 + 1)) + 50;
  //             return { categoryName, count: fallbackCount, isSuccess: false };
  //           }
  //         })
  //       );

  //       batchResults.forEach(({ categoryName, count, complaintNumbers }) => {
  //         updatedCategories[categoryName] = {
  //           ...updatedCategories[categoryName],
  //           count,
  //           complaintNumbers: complaintNumbers || [],
  //         };
  //       });

  //       await new Promise((resolve) => setTimeout(resolve, 200));
  //     }


  //     const verificationTotal = Object.values(updatedCategories).reduce((sum, category) => sum + (category.count || 0), 0);

  //     if (verificationTotal !== totalComplaints) {
  //       console.warn(`Total mismatch! Calculated: ${totalComplaints}, Verification: ${verificationTotal}. Using verification total.`);
  //       totalComplaints = verificationTotal;
  //     }

  //     try {
  //       localStorage.setItem(SUBCATEGORY_CACHE_KEY, JSON.stringify({
  //         query: categoryData[0], // Cache the category name (query)
  //         prompt: categoryData[1].prompt,
  //         complaintNumbers: categoryData[1].complaintNumbers,
  //         timestamp: Date.now(),
  //         data: {
  //           categories: updatedCategories,
  //           totalCount: categoryData[1]?.total_counts || 0
  //         }
  //       }));
  //     } catch (cacheError) {
  //       console.warn('Failed to cache subcategory data:', cacheError);
  //     }

  //     return {
  //       updatedData: updatedCategories,
  //       totalCount: categoryData[1].total_counts,
  //       totalCategories: categoryNames.length,
  //     };
  //   } catch (error) {
  //     console.error('Error in fetchCategoryWithCount:', error);
  //     throw error;
  //   }
  // },


  fetchCategoryWithCount: async (categoryData, filters = {}) => {
    const SUBCATEGORY_CACHE_KEY = "currentSubcategoryData";
    const CACHE_EXPIRY_HOURS = 24;

    const isCacheValid = (timestamp) => {
      if (!timestamp) return false;
      const age = (Date.now() - timestamp) / (1000 * 60 * 60);
      return age < CACHE_EXPIRY_HOURS;
    };

    // 1️⃣ Try cache first
    try {
      const cached = JSON.parse(localStorage.getItem(SUBCATEGORY_CACHE_KEY) || "{}");

      if (
        cached?.prompt === categoryData[1].prompt &&
        cached?.timestamp &&
        isCacheValid(cached.timestamp)
      ) {
        return {
          updatedData: cached.data.categories || {},
          totalCount: cached.data.totalCount || 0,
          totalCategories: Object.keys(cached.data.categories || {}).length
        };
      }
    } catch (err) {
      console.warn("Failed to read subcategory cache:", err);
    }

    // 2️⃣ Prepare payload for combined API
    const startDate = filters.startDate
      ? new Date(filters.startDate).toISOString().split("T")[0]
      : new Date(new Date().getFullYear() - 2, 0, 1).toISOString().split("T")[0];

    const endDate = filters.endDate
      ? new Date(filters.endDate).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0];

    try {
      const response = await axios.post(
        API_ENDPOINTS.SUBCATEGORY_WITH_COUNTS, // <-- NEW API
        {
          input_prompt: categoryData[1].prompt,
          value: filters?.value || 1,
          start_date: startDate,
          end_date: endDate,
          threshold: filters?.threshold || 1.5,
          purchaseCity: "All",
          stateName: "All",
          complaintType: "All",
          complaintMode: "All",
          companyName: "All",
          complaintStatus: "All",
          complainNumbers: categoryData[1].complaintNumbers || ["NA"],
          max_retries: 3
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`
          },
          timeout: 35000
        }
      );

      const subcategories = response?.data?.subcategories || [];

      if (!subcategories.length) {
        return {
          updatedData: {},
          totalCount: 0,
          totalCategories: 0
        };
      }

      // 3️⃣ Convert response → old structure
      const updatedCategories = {};
      let verificationTotal = 0;

      subcategories.forEach((item) => {
        updatedCategories[item.subcategory] = {
          prompt: item.prompt || "",
          count: item.count || 0,
          complaintNumbers: item.complaintNumbers || []
        };
        verificationTotal += item.count || 0;
      });

      // 4️⃣ Cache result
      try {
        localStorage.setItem(
          SUBCATEGORY_CACHE_KEY,
          JSON.stringify({
            query: categoryData[1].prompt,
            title: categoryData[0],
            prompt: categoryData[1].prompt,
            count: verificationTotal,
            complaintNumbers: categoryData[1].complaintNumbers,
            timestamp: Date.now(),
            data: {
              categories: updatedCategories,
              totalCount: verificationTotal
            }
          })
        );
      } catch (err) {
        console.warn("Failed to cache subcategory data:", err);
      }

      // 5️⃣ Return EXACT shape expected by UI
      return {
        updatedData: updatedCategories,
        totalCount: verificationTotal,
        totalCategories: subcategories.length
      };
    } catch (error) {
      console.error("Error in fetchCategoryWithCount (combined):", error);
      throw error;
    }
  },

  fetchSubcategories: async (params) => {
    const startDate = params.startDate
      ? new Date(params.startDate).toISOString().split("T")[0]
      : new Date(new Date().getFullYear() - 2, 0, 1).toISOString().split("T")[0];

    const endDate = params.endDate
      ? new Date(params.endDate).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0];

    let complaintNumbersToUse = params.complaintNumbers || ["NA"];
    if (!complaintNumbersToUse || complaintNumbersToUse.length === 0 || (complaintNumbersToUse.length === 1 && complaintNumbersToUse[0] === "NA")) {
      try {
        const rcaResponse = await api.post(API_ENDPOINTS.SEMANTIC_RCA, {
          query: params.prompt,
          start_date: startDate,
          end_date: endDate,
          threshold: params.threshold || 1.3,
          value: params.value || 1,
          purchaseCity: 'All',
          stateName: 'All',
          complaintMode: 'All',
          companyName: 'All',
          complaintStatus: 'All',
          complainNumbers: params.complainNumbers
        });

        if (rcaResponse.data && rcaResponse.data.complaintNumbers && rcaResponse.data.complaintNumbers.length > 0) {
          complaintNumbersToUse = rcaResponse.data.complaintNumbers;
        }
      } catch (e) {
        console.warn("Failed to pre-fetch complaint numbers via Semantic RCA:", e);
      }
    }

    try {
      const response = await axios.post(
        API_ENDPOINTS.SUBCATEGORY_WITH_COUNTS,
        {
          input_prompt: params.prompt,
          value: params.value || 1,
          start_date: startDate,
          end_date: endDate,
          threshold: params.threshold || 1.5,
          purchaseCity: "All",
          stateName: "All",
          complaintMode: "All",
          companyName: "All",
          complaintStatus: "All",
          complainNumbers: complaintNumbersToUse,
          max_retries: 3
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`
          },
          timeout: 20000
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in fetchSubcategories:", error);
      throw error;
    }
  },

  fetchSectorDsitribution: async (params) => {
    const response = await api.post(API_ENDPOINTS.FEEDBACK_DISTRIBUTION, {
      start_date: params.startDate,
      end_date: params.endDate,
      attribute: params.attribute || 'Sector',
      Sector: params.Sector || 'All',
      CompanyName: params.CompanyName || 'All',
      Category: params.Category || 'All',
      skip: params.skip || 0,
      limit: params.limit || 10
    });
    return response.data;
  },

  // fetchCompanyDistribution: async (filters, skip = 0, limit = 25) => {
  //   const SUB_COMPANY_CACHE_KEY = "subCompanyCache";
  //   const CACHE_EXPIRY_HOURS = 24;

  //   const cacheKey = SUB_COMPANY_CACHE_KEY;

  //   try {
  //     const cached = JSON.parse(localStorage.getItem(cacheKey) || "{}");
  //     const isCacheValid = (timestamp) => {
  //       if (!timestamp) return false;
  //       const age = (Date.now() - timestamp) / (1000 * 60 * 60);
  //       return age < CACHE_EXPIRY_HOURS;
  //     }
  //     if (cached?.prompt === filters.query && cached?.timestamp && isCacheValid(cached.timestamp)) {
  //       return cached.data;
  //     }
  //   } catch (error) {
  //     console.error('Error reading company cache:', error);
  //   }


  //   const start_date = filters.startDate
  //     ? new Date(filters.startDate).toISOString().split('T')[0]
  //     : new Date(new Date().getFullYear() - 1, 0, 1).toISOString().split('T')[0];

  //   const end_date = filters.endDate
  //     ? new Date(filters.endDate).toISOString().split('T')[0]
  //     : new Date().toISOString().split('T')[0];

  //   const response = await api.post(
  //     `${API_URL}/get_company_distribution`,
  //     {
  //       query: filters.query || "",
  //       start_date: start_date,
  //       end_date: end_date,
  //       value: filters.value || 1,
  //       companyName: "All",
  //       threshold: 1.3,
  //       complaint_numbers: filters.complaintNumbers || ["NA"],
  //       skip: skip,
  //       limit: limit,
  //     }
  //   );

  //   try {
  //     localStorage.setItem(cacheKey, JSON.stringify({
  //       prompt: filters.query,
  //       timestamp: Date.now(),
  //       data: response.data.distribution
  //     }));
  //   } catch (error) {
  //     console.error('Error writing company cache:', error);
  //   }
  //   return response.data.distribution;
  // },

  // services/apiService.js

  fetchCompanyDistribution: async (filters, skip = 0, limit = 25) => {
    const SUB_COMPANY_CACHE_KEY = "subCompanyCache";
    const CACHE_EXPIRY_HOURS = 24;

    // Only use cache for the first page (skip = 0)
    if (skip === 0) {
      const cacheKey = SUB_COMPANY_CACHE_KEY;

      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey) || "{}");
        const isCacheValid = (timestamp) => {
          if (!timestamp) return false;
          const age = (Date.now() - timestamp) / (1000 * 60 * 60);
          return age < CACHE_EXPIRY_HOURS;
        }

        if (cached?.prompt === filters.query &&
          cached?.timestamp &&
          isCacheValid(cached.timestamp) &&
          cached?.data?.distribution) {
          return {
            distribution: cached.data.distribution.slice(skip, skip + limit),
            total: cached.data.total || cached.data.distribution.length
          };
        }
      } catch (error) {
        console.error('Error reading company cache:', error);
      }
    }

    const start_date = filters.startDate
      ? new Date(filters.startDate).toISOString().split('T')[0]
      : new Date(new Date().getFullYear() - 1, 0, 1).toISOString().split('T')[0];

    const end_date = filters.endDate
      ? new Date(filters.endDate).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0];

    const response = await api.post(
      `${API_URL}/get_company_distribution`,
      {
        query: filters.query || "",
        start_date: start_date,
        end_date: end_date,
        value: filters.value || 1,
        companyName: "All",
        threshold: 1.3,
        complaint_numbers: filters.complaintNumbers || ["NA"],
        skip: skip,
        limit: limit,
      }
    );



    // Cache the first page result
    if (skip === 0) {
      try {
        localStorage.setItem(SUB_COMPANY_CACHE_KEY, JSON.stringify({
          prompt: filters.query,
          timestamp: Date.now(),
          data: response.data.distribution
        }));
      } catch (error) {
        console.error('Error writing company cache:', error);
      }
    }

    return response.data.distribution;
  },

  fetchAllCompanyDistribution: async (filters, skip = 0, limit = 25) => {
    const SUB_COMPANY_CACHE_KEY = "subCompanyCache";
    const CACHE_EXPIRY_HOURS = 24;

    // Only use cache for the first page (skip = 0)
    if (skip === 0) {
      const cacheKey = SUB_COMPANY_CACHE_KEY;

      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey) || "{}");
        const isCacheValid = (timestamp) => {
          if (!timestamp) return false;
          const age = (Date.now() - timestamp) / (1000 * 60 * 60);
          return age < CACHE_EXPIRY_HOURS;
        }

        if (cached?.prompt === filters.query &&
          cached?.timestamp &&
          isCacheValid(cached.timestamp) &&
          cached?.data?.distribution) {
          return {
            distribution: cached.data.distribution.slice(skip, skip + limit),
            total: cached.data.total || cached.data.distribution.length
          };
        }
      } catch (error) {
        console.error('Error reading company cache:', error);
      }
    }

    const start_date = filters.startDate
      ? new Date(filters.startDate).toISOString().split('T')[0]
      : new Date(new Date().getFullYear() - 1, 0, 1).toISOString().split('T')[0];

    const end_date = filters.endDate
      ? new Date(filters.endDate).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0];

    const response = await api.post(
      `${API_URL}/get_all_company_distribution`,
      {
        query: filters.query || "",
        start_date: start_date,
        end_date: end_date,
        purchaseCity: 'All',
        complaintMode: 'All',
        complaintStatus: 'All',
        stateName: 'All',
        value: filters.value || 1,
        companyName: "All",
        threshold: 1.3,
        complainNumbers: filters.complaintNumbers || ["NA"],
        skip: skip,
        size: limit,
      }
    );



    // Cache the first page result
    if (skip === 0) {
      try {
        localStorage.setItem(SUB_COMPANY_CACHE_KEY, JSON.stringify({
          prompt: filters.query,
          timestamp: Date.now(),
          data: response.data
        }));
      } catch (error) {
        console.error('Error writing company cache:', error);
      }
    }

    return response.data;
  },

  fetchFeedbackKeyWords: async (params) => {
    const response = await api.post(API_ENDPOINTS.FEEDBACK_KEYWORD, {
      sectorName: 'All',
      companyName: params.CompanyName,
      categoryName: 'All',
      offset: 3,
      limit: 25
    })
    return response.data
  },

  fetchFeedbackDistribution: async (params) => {
    console.log("paramas in api", params)
    const start_date = params.startDate
      ? new Date(params.startDate).toISOString().split('T')[0]
      : new Date(new Date().getFullYear(), 0, 1).toISOString().split('T')[0];

    const end_date = params.endDate
      ? new Date(params.endDate).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0];
    const response = await api.post(API_ENDPOINTS.FEEDBACK_DISTRIBUTION, {
      start_date: start_date,
      end_date: end_date,
      attribute: params.attribute,
      Sector: params.Sector || "All",
      CompanyName: params.CompanyName || "All",
      Category: params.Category || "All",
      skip: params.skip || 0,
      limit: params.limit || 1000,
    });
    return response.data;
  },

  fetchFeedbackStats: async (filters) => {
    const start_date = filters.startDate
      ? new Date(filters.startDate).toISOString().split('T')[0]
      : new Date(new Date().getFullYear(), 0, 1).toISOString().split('T')[0];

    const end_date = filters.endDate
      ? new Date(filters.endDate).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0];

    const response = await api.get(API_ENDPOINTS.FEEDBACK_STATS, {
      params: {
        sector: filters.Sector || "All",
        companyname: filters.CompanyName || "All",
        category: filters.Category || "All",
        start_date,
        end_date
      }
    });
    return response.data;
  },

  fetchCategoryAlerts: async (filters, categories = null) => {
    const SUB_ALERT_CACHE = "subAlertCache"
    const CACHE_EXPIRY_HOURS = 24;
    const cacheKey = SUB_ALERT_CACHE;

    // If we have categories (drilled down view), we fetch individual alerts for each
    if (categories && Array.isArray(categories) && categories.length > 0) {
      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey) || "{}");
        const isCacheValid = (timestamp) => {
          if (!timestamp) return false;
          const age = (Date.now() - timestamp) / (1000 * 60 * 60);
          return age < CACHE_EXPIRY_HOURS;
        }

        if (cached?.prompt === filters.query && cached?.timestamp && isCacheValid(cached.timestamp)) {
          return cached.data;
        }

        let date = filters.endDate
          ? new Date(filters.endDate)
          : new Date();

        date.setMonth(date.getMonth() - 4);

        const start_date = date.toISOString().split('T')[0];

        const payload = {
          last_days: 84,
          given_date: start_date,
          value: filters.value || 1,
          purchaseCity: "All",
          stateName: "All",
          complaintMode: "All",
          companyName: "All",
          complaintStatus: "All",
          threshold: filters?.threshold || 1.3,
          complainNumbers: filters.complaintNumbers || ["NA"]
        };

        const batchSize = 5;
        let allAlerts = [];

        for (let i = 0; i < categories.length; i += batchSize) {
          const batch = categories.slice(i, i + batchSize);
          const batchPromises = batch.map(async (categoryName) => {
            try {
              const encodedCategory = encodeURIComponent(categoryName);
              const response = await api.post(
                `${API_URL}/get_individual_category_alert/${encodedCategory}`,
                payload
              );
              const result = response.data;
              if (Array.isArray(result)) {
                return result.map(alert => ({ ...alert, category: categoryName }));
              } else if (result && typeof result === 'object') {
                return { ...result, category: categoryName };
              }
              return null;
            } catch (error) {
              console.warn(`Failed to fetch alert for ${categoryName}`, error);
              return null;
            }
          });

          const batchResults = await Promise.all(batchPromises);
          // Flatten and filter nulls
          const validResults = batchResults
            .flat()
            .filter(item => item !== null && item !== undefined);

          allAlerts = [...allAlerts, ...validResults];

          // Small delay between batches
          if (i + batchSize < categories.length) {
            await new Promise(resolve => setTimeout(resolve, 200));
          }
        }

        // Cache the result
        try {
          localStorage.setItem(cacheKey, JSON.stringify({
            prompt: filters.query,
            timestamp: Date.now(),
            data: allAlerts
          }));
        } catch (error) {
          console.error('Failed to cache alert data:', error);
        }

        return allAlerts;

      } catch (error) {
        console.error('Error fetching individual category alerts:', error);
        return [];
      }
    }


    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey) || "{}");
      const isCacheValid = (timestamp) => {
        if (!timestamp) return false;
        const age = (Date.now() - timestamp) / (1000 * 60 * 60);
        return age < CACHE_EXPIRY_HOURS;
      }
      if (cached?.prompt === filters.query && cached?.timestamp && isCacheValid(cached.timestamp)) {
        return cached.data;
      } else if (cached?.prompt && cached?.prompt !== filters.query) {
        console.log("✅ different query detected:", filters.query);
      }

      const startDate = filters.startDate
        ? new Date(filters.startDate).toISOString().split('T')[0]
        : new Date().toISOString().split('T')[0];

      const response = await api.post(API_ENDPOINTS.CATEGORY_ALERT,
        {
          last_days: 84,
          given_date: startDate,
          value: filters?.value || 1,
          CityName: "All",
          stateName: "All",
          complaintType: "All",
          complaintMode: "All",
          category: "All",
          complaintStatus: "All",
          threshold: filters?.threshold || 1.3,
          complaint_numbers: filters.complaintNumbers || ["NA"]
        }
      )
      const data = response.data;
      try {
        localStorage.setItem(cacheKey, JSON.stringify({
          prompt: filters.query,
          timestamp: Date.now(),
          data: data
        }));
      } catch (error) {
        console.error('Failed to cache alert data:', error);
      }
      return data;
    } catch (error) {
      console.error('Error reading Alert cache', error);
    }
  },

  fetchFeedbackByRating: async (params) => {
    const {
      rating,
      sector = 'All',
      companyname = 'All',
      category = 'All',
      start_date,
      end_date,
      skip = 0,
      size = 100
    } = params;

    const response = await api.get(`${API_ENDPOINTS.FEEDBACK_BY_RATING}/${rating}`, {
      params: {
        sector,
        companyname,
        category,
        start_date,
        end_date,
        skip,
        size
      }
    });
    return response.data;
  },

  fetchCompanyOffers: async (filters) => {
    const start_date = filters.startDate
      ? new Date(filters.startDate).toISOString().replace('T', ' ').split('.')[0]
      : "2025-01-01 00:00:00";

    const end_date = filters.endDate
      ? new Date(filters.endDate).toISOString().replace('T', ' ').split('.')[0]
      : "2025-06-30 23:59:59";

    const response = await axios.post(API_ENDPOINTS.COMPANY_OFFERS, {
      skip: 0,
      size: 10,
      start_date,
      end_date
    }, {
      headers: {
        'accept': 'application/json',
        'Authorization': `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  }

};